export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50 block mb-3">
                黑料视频
              </span>
              <p className="text-sm text-background-400 leading-relaxed">
                黑料视频致力于聚合全网热门黑料视频资源，提供黑料视频在线观看与黑料视频下载一站式服务。本站持续更新官网最新地址及手机app下载入口，帮助用户快速获取最新黑料视频内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><a href="#media" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热门视频</a></li>
                <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a></li>
                <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热度排行</a></li>
                <li><a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">手机App</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
              <ul className="space-y-2">
                <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
                <li><a href="#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
                <li><a href="#about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">暂无具体合作伙伴信息</p>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 黑料视频. 本站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}